import {useTranslation} from "@i18n/client";
import {I18nNamespace} from "@i18n";
import React from "react";
import HoursOfOperation from "./HoursOfOperation";
import {WithNextSlot} from "@components/Booking/useNextAvailable";
import {Location} from "@components/Booking/LocationSelection/types";

const NoSlots = ({location}: {location: WithNextSlot<Location>}) => {
  const i18n = useTranslation(I18nNamespace.WEB_SCHEDULING);
  return (
    <span className="font-i text-sm text-gray-600">
      <span>{i18n.t("No availability", {ns: "web-scheduling"})}</span>
      <span> · </span>
      <HoursOfOperation disabled={true} location={location} />
    </span>
  );
};

export default React.memo(NoSlots);
